const navCols = [
  {
    title: 'COMPANY',
    links: ['회사소개', '경영이념', '연혁', '인증현황'],
    hrefs: ['#about', '#about', '#about', '#about'],
  },
  {
    title: 'PRODUCTS',
    links: ['산업기계설비', '도장설비', '맞춤형 솔루션'],
    hrefs: ['#industrial', '#painting', '#products'],
  },
  {
    title: 'CONTACT',
    links: ['견적 문의', '오시는 길'],
    hrefs: ['#contact', '#contact'],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#F2F0EC] pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-white rounded-2xl px-10 py-12 mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
            {/* Brand Block */}
            <div className="lg:col-span-1">
              <img
                src="https://public.readdy.ai/ai/img_res/1f13c3a0-d7e2-4d47-86d7-8998576e56ab.png"
                alt="SJ Engineering Logo"
                className="h-12 w-auto object-contain mb-4"
              />
              <p className="text-sm text-gray-500 leading-relaxed">
                산업기계설비 및 도장설비 제조 전문기업<br />
                최고의 기술력으로 고객의 성공을<br />
                함께 만들어 갑니다.
              </p>
              <div className="mt-5 flex items-center gap-2">
                <span className="inline-block w-2 h-2 rounded-full bg-[#C0392B]" />
                <span className="text-xs text-gray-400">사업자등록번호: 140-81-90658</span>
              </div>
            </div>

            {/* Nav Columns */}
            {navCols.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs font-bold tracking-widest text-[#1C1C1C] mb-5">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((link, i) => (
                    <li key={link}>
                      <a
                        href={col.hrefs[i]}
                        onClick={(e) => { e.preventDefault(); handleClick(col.hrefs[i]); }}
                        className="text-sm text-gray-500 hover:text-[#C0392B] transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-3 px-2">
          <p className="text-xs text-gray-400">
            &copy; 2026 (주)에스제이엔지니어링. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-400">개인정보처리방침</span>
            <span className="text-gray-300">|</span>
            <span className="text-xs text-gray-400">이용약관</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
